import { enumSCArrowVariants } from "../constants";

/**
 * @typedef {import('./QXWSMgr').QXWSMgr} QXWSMgr
 */

export class Globals {
  /** @type {Nullable<QApp>} */
  static _app = null;
  /** @type {Nullable<number>} */
  static _dpr = null;
  /** @type {Nullable<QXWSMgr>} */
  static _wsMgr = null;
  /** @type {Nullable<QFileMgr>} */
  static _fileMgr = null;
  /** @type {Nullable<QAccountInfo>} */
  static _accountInfo = null;
  /** @type {Nullable<QRFCMgr>} */
  static _rfcMgr = null;
  /** @type {Nullable<QHoverMgr>} */
  static _hoverMgr = null;
  /** @type {Nullable<QStringMgr>} */
  static _stringMgr = null;
  /** @type {Nullable<QUIConfig>} */
  static _uiConfig = null;
  static _uiFont = null;
  /** @type {Nullable<any>} */
  static _pubSettings = null;
  /** @type {Nullable<any>} */
  static _publishRef = null;
  static _publishScaler = null;
  static _pageTimer = null;
  static _pubPanel = null;
  static _timerMgr = null;
  static _bookRenderInfo = null;
  static _preflightInfo = null;
  static _svgRenderInfo = null;
  static _svrChartMgr = null;
  static _fileMgrWS = null;

  static gSubscriberId = null;
  static gDocSubscriberId = null;
  static fileMgrSubscriberId = null;
  static uiStateSubscriberId = null;
  static gViewMgrSubscriberId = null;
  static contextMenuSubscriberId = null;
  static recordInfoSubscriberId = null;
  static sidebarSubscriberId = null;

  static _renderStart = null;
  static _flashElement = null;
  static _flastTimer = null;
  static _sessionTimerRef = null;
  static _scaleFactor = null;
  static _ctpRef = null;
  static _pubPerf = false;
  static _uploadPubContent = false;

  static _altLayerToRender = null;
  static _sessionKey = null;
  static _measureBuffer = null;
  static _textHeightCache = null;
  static _sessionCounter = 0;
  static _rolling = 0;
  static _average = 0;
  static _reportPerf = false;
  static _allowRender = true;
  static _startLog = false;
  static _mouseUpHandled = false;

  static _decimalMarker = ".";
  static _thousandSeparator = ",";
  static _svgUID = 1;
  static _keypadPanel = false;

  static _mobileDevice = false;
  static _lastMultiTouchScale = 1;
  static _lastMultiTouchDim = null;

  static _gestureActive = false;
  static _gestureStartCoords = [];
  static _gestureScaleFactor = 1;
  static _firstRun = true;
  static _mcTimer = null;
  static _startTime = null;
  static _reportPerf2 = false;
  static _startImport = null;
  static _pageOptimizeSpacer = true;
  static _targetScore = 40;
  static _themeMode = null;

  static _browserStr = "";
  static _userBrowser = -1;
  static _wsRefFinishDownload = null;

  static _priorTextFormat = null;
  static _priorCellFormat = null;
  static _maskCanvas = null;
  static _refreshDiagnostic = null;
  static _doRefreshDiagnostic = false;

  static _reportPerf3 = false;
  static _reportPerf4 = false;
  static _startOpen = null;
  static _startSave = null;
  static _scArrowStyle = enumSCArrowVariants.miniarrow;
  static _startZoom = 1;
  static _nodeID = 0;
  static _journalID = 1;

  static _timeoutLen = 1000 * 60 * 60;
  static _graceTime = 900;
}
